import * as React from 'react'
import cn from 'classnames'

type CheckIconProps = {
  className?: string
  completed: boolean
}

export const CheckIcon = React.forwardRef<SVGSVGElement, CheckIconProps>(
  (props, ref) => {
    const { completed, className, ...restProps } = props
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="1em"
        height="1em"
        viewBox="0 0 256 256"
        aria-hidden="true"
        className={cn('h-4 w-4 group', className)}
        ref={ref}
        {...restProps}
      >
        <rect width="256" height="256" fill="none" />
        <circle
          cx="128"
          cy="128"
          r="96"
          stroke="currentColor"
          className={cn(
            'transition-colors',
            completed
              ? 'stroke-theme-50 fill-theme-50'
              : 'stroke-gray-600 fill-none'
          )}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="24"
        />
        <polyline
          points="172 104 113.3 160 84 132"
          fill="none"
          stroke="white"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="24"
        />
      </svg>
    )
  }
)

CheckIcon.displayName = 'CheckIcon'
